/** Màu tag theo grade A–F của SeoAnalyzer (dùng chung các tab Phân tích đối thủ). */
export const GRADE_COLORS = {
	A: 'green',
	B: 'cyan',
	C: 'gold',
	D: 'orange',
	F: 'red',
};
